export default class DataStore {
  static instance: DataStore
  map: Map<any,any>

  constructor() {
    this.map = new Map()
  }

  static getInstance() {
    if (!DataStore.instance) {
      DataStore.instance = new DataStore()
    }
    return DataStore.instance
  }

  put(key: any, value: any) {
    this.map.set(key, value)
    return this
  }

  get(key: any) {
    return this.map.get(key)
  }

  delete(key: any) {
    this.map.delete(key)
  }
}